var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMedicine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 11C12.5523 11 13 11.4477 13 12V13H14C14.5523 13 15 13.4477 15 14C15 14.5523 14.5523 15 14 15H13V16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16V15H10C9.44772 15 9 14.5523 9 14C9 13.4477 9.44772 13 10 13H11V12C11 11.4477 11.4477 11 12 11Z",
    fill: "#262626"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 4C5.89543 4 5 4.89543 5 6V8C5 8.53277 5.20831 9.01688 5.54793 9.37533L4.3359 11.1934C4.11688 11.5219 4 11.9079 4 12.3028V18C4 19.1046 4.89543 20 6 20H18C19.1046 20 20 19.1046 20 18V12.3028C20 11.9079 19.8831 11.5219 19.6641 11.1934L18.4521 9.37533C18.7917 9.01688 19 8.53277 19 8V6C19 4.89543 18.1046 4 17 4H7ZM16.4648 10H7.53518L6 12.3028V18H18V12.3028L16.4648 10ZM17 8V6H7V8H17Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMedicine);
export default __webpack_public_path__ + "static/media/icon_medicine.3e39f37389c96e4e5e6ffb1dc79e7647.svg";
export { ForwardRef as ReactComponent };